export class User {
  public id!: number;
  public username!: string;
  public email!: string;
  public password?: string;
  public firstname!: string;
  public lastname!: string;
  public language?: string;
  public roles?: string[] = ["R_PARTITION_USER"];
  public partitionId!: number;
  public partitionName?: string;
  public enabled: boolean = true;
  public linkedPartitions?: number[];
  public welcomeSent: boolean = false;

  constructor() {
  }
}
